document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var state = {
    step: 1,
    vehicle: null,
    coverage: null,
    customerName: '',
  };

  var qbProductsData = null;

  function getStepLabels() {
    var stepsEl = document.querySelector('[data-qb-steps]');
    if (!stepsEl || !stepsEl.dataset.qbStepLabels) return [];
    return stepsEl.dataset.qbStepLabels.split('|');
  }

  function isDesktop() {
    if (!window.matchMedia) return true;
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function updateStepsUI(currentStep) {
    var stepEls = document.querySelectorAll('[data-qb-step]');
    if (!stepEls.length) return;

    stepEls.forEach(function (el) {
      var n = parseInt(el.dataset.qbStep, 10);
      if (isNaN(n)) return;
      el.dataset.state = n < currentStep ? 'done' : n === currentStep ? 'active' : 'pending';
    });

    var labels = getStepLabels();
    var numEl = document.querySelector('[data-qb-current-num]');
    var labelEl = document.querySelector('[data-qb-current-label]');
    if (numEl) numEl.textContent = currentStep;
    if (labelEl && labels[currentStep - 1]) labelEl.textContent = labels[currentStep - 1];
  }

  function showStep(n) {
    var panels = document.querySelectorAll('[data-qb-panel]');
    if (!panels.length) return;

    panels.forEach(function (panel) {
      panel.hidden = panel.dataset.qbPanel !== String(n);
    });

    state.step = n;
    updateStepsUI(n);

    if (n === 4) renderQuoteStep();
  }

  function setVehicleName(name) {
    var nameEls = document.querySelectorAll('[data-qb-vehicle-name]');
    nameEls.forEach(function (el) {
      el.textContent = name;
    });
  }

  function setCoverageName(name) {
    var els = document.querySelectorAll('[data-qb-coverage-name]');
    els.forEach(function (el) {
      el.textContent = name;
    });
  }

  function showCoverageGroup(vehicleHandle) {
    var groups = document.querySelectorAll('[data-qb-coverage-group]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      group.hidden = group.dataset.qbCoverageGroup !== vehicleHandle;
    });
  }

  function setNextEnabled(enabled) {
    var nextButtons = document.querySelectorAll('[data-qb-next]');
    nextButtons.forEach(function (btn) {
      btn.disabled = !enabled;
    });
  }

  function clearCoverageSelection(scopeEl) {
    if (!scopeEl) return;
    var cards = scopeEl.querySelectorAll('.qb-coverage-card');
    cards.forEach(function (card) {
      card.classList.remove('is-selected');
    });
  }

  function initVehicleStep() {
    var vehicleButtons = document.querySelectorAll('[data-qb-vehicle]');
    if (!vehicleButtons.length) return;

    vehicleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.qbVehicle;
        if (!handle) return;

        var nameEl = btn.querySelector('.qb-vehicle-card__name');
        var name = nameEl && nameEl.textContent ? nameEl.textContent.trim() : '';

        setVehicleName(name);
        showCoverageGroup(handle);
        setNextEnabled(false);

        state.vehicle = handle;
        state.coverage = null;

        showStep(2);
      });
    });
  }

  function initCoverageStep() {
    var coverageCards = document.querySelectorAll('.qb-coverage-card');
    if (!coverageCards.length) return;

    coverageCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var handle = card.dataset.qbCoverage;
        if (!handle) return;

        var group = card.closest('[data-qb-coverage-group]');
        clearCoverageSelection(group);
        card.classList.add('is-selected');

        var title = card.dataset.fullTitle || (card.querySelector('.qb-coverage-card__name') ? card.querySelector('.qb-coverage-card__name').textContent.trim() : '');

        state.coverage = handle;
        setCoverageName(title);

        if (isDesktop()) {
          showStep(3);
        } else {
          setNextEnabled(true);
        }
      });
    });

    var nextButtons = document.querySelectorAll('[data-qb-next]');
    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!state.coverage) return;
        showStep(3);
      });
    });
  }

  function initInfoButtons() {
    var infoButtons = document.querySelectorAll('[data-qb-info]');
    if (!infoButtons.length) return;

    infoButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var handle = btn.dataset.qbInfo;
        if (!handle) return;
        showCoveragePopup(handle);
      });
    });
  }

  function showCoveragePopup(handle) {
    var data = getProductsData();
    if (!data) return;
    var product = null;
    Object.keys(data).forEach(function (v) {
      data[v].forEach(function (p) { if (p.handle === handle) product = p; });
    });
    if (!product) return;

    var displayTitle = product.title.replace(/^(Sedan|Coupe|Truck|SUV|Truck-SUV)\s+/i, '');
    var warrantyText = product.warrantyYears ? product.warrantyYears + '-Year Warranty' : (product.warranty || '');

    var overlay = document.createElement('div');
    overlay.className = 'qb-info-overlay';
    overlay.innerHTML = [
      '<div class="qb-info-box">',
        '<div class="qb-info-head">',
          '<button type="button" class="qb-info-close" aria-label="Close">✕</button>',
          product.tag ? '<div class="qb-info-eyebrow">' + product.tag + '</div>' : '',
          '<h2 class="qb-info-title">' + displayTitle + '</h2>',
          warrantyText ? '<div class="qb-info-badge">' + warrantyText + '</div>' : '',
        '</div>',
        '<div class="qb-info-body">',
          product.description ? '<p class="qb-info-desc">' + product.description + '</p>' : '',
          (Array.isArray(product.additionalInfo) && product.additionalInfo.length) ? [
            '<div class="qb-info-points-label">What\'s included</div>',
            '<div class="qb-info-points">',
              product.additionalInfo.map(function (pt) {
                return '<div class="qb-info-point"><span class="qb-info-point-dot">◆</span><span>' + pt + '</span></div>';
              }).join(''),
            '</div>'
          ].join('') : '',
          '<div class="qb-info-foot">',
            '<button type="button" class="qb-info-got">Got it</button>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(overlay);

    var bodyEl = overlay.querySelector('.qb-info-body');
    var ulEl = bodyEl && bodyEl.querySelector('ul');
    if (ulEl) {
      var inclLabel = document.createElement('div');
      inclLabel.className = 'qb-info-points-label';
      inclLabel.textContent = "What's included";
      ulEl.parentNode.insertBefore(inclLabel, ulEl);
    }

    function closePopup() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
    overlay.querySelector('.qb-info-close').addEventListener('click', closePopup);
    overlay.querySelector('.qb-info-got').addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { closePopup(); document.removeEventListener('keydown', esc); }
    });
  }

  function initBackButtons() {
    var backButtons = document.querySelectorAll('[data-qb-back]');
    if (!backButtons.length) return;

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = parseInt(btn.dataset.qbBack, 10);
        if (isNaN(target) || target < 1) target = 1;
        showStep(target);
      });
    });
  }

  function captureFormName() {
    var input = document.querySelector('.qb-hulk-form input[type="text"]');
    if (input && input.value.trim()) {
      state.customerName = input.value.trim();
    }
  }

  function watchHulkFormSuccess() {
    var container = document.querySelector('[data-qb-hulk-form]');
    if (!container) return;

    var observer = new MutationObserver(function () {
      if (state.step !== 3) return;
      var successNode = container.querySelector('.pxfg-success, .thank-you, [class*="success"]');
      var alreadySubscribed = !successNode && Array.from(container.querySelectorAll('*')).some(function (el) {
        return el.children.length === 0 && el.textContent.toLowerCase().indexOf('already subscribed') !== -1;
      });
      if (successNode || alreadySubscribed) {
        captureFormName();
        showStep(4);
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  // ---- Step 4: quote rendering ----

  function stripCents(price) {
    if (!price) return price;
    return price.replace(/[.,]00$/, '');
  }

  function getProductsData() {
    if (qbProductsData) return qbProductsData;
    var script = document.querySelector('[data-qb-products-data]');
    if (!script || !script.textContent) return null;

    try {
      qbProductsData = JSON.parse(script.textContent);
    } catch (e) {
      qbProductsData = null;
    }
    return qbProductsData;
  }

  function renderPoints(container, points) {
    if (!container) return;
    container.innerHTML = '';
    if (!points || !points.length) return;

    points.forEach(function (text) {
      var row = document.createElement('div');
      row.className = 'qb-point-row';

      var dot = document.createElement('span');
      dot.className = 'qb-point-row__dot';
      dot.textContent = '◆';

      var label = document.createElement('span');
      label.textContent = text;

      row.appendChild(dot);
      row.appendChild(label);
      container.appendChild(row);
    });
  }

  function goToCheckout(variantId) {
    if (!variantId) return;
    window.location.href = '/cart/' + variantId + ':1';
  }

  // ---- Booking Wizard ----

  var BWIZ_BACKEND = 'https://skq-schedule-backend.netlify.app/.netlify/functions';

  var bwizState = { step: 1, zip: '', location: null, selectedTime: null, variantId: null };

  var BWIZ_STATE_NAMES = {
    AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',
    CO:'Colorado',CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',
    HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',
    KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',
    MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',
    MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',
    NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',
    OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',
    SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',
    VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',
    DC:'Washington D.C.'
  };

  function bwizPostJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        try { return JSON.parse(text); } catch (e) { return null; }
      });
    }).catch(function () { return null; });
  }

  function bwizDistanceMi(lat1, lon1, lat2, lon2) {
    var R = 3959;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function bwizConvertISO(timeString, dateString) {
    var datePart = dateString.split('T')[0];
    var match = timeString.match(/(\d+:\d+:\d+)\s(AM|PM)/);
    if (!match) return null;
    var parts = match[1].split(':').map(Number);
    var h = parts[0], m = parts[1], s = parts[2];
    var ampm = match[2];
    if (ampm === 'PM' && h !== 12) h += 12;
    if (ampm === 'AM' && h === 12) h = 0;
    return new Date(
      datePart + 'T' + String(h).padStart(2, '0') + ':' +
      String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0') + 'Z'
    ).toISOString();
  }

  function bwizShowPanel(n) {
    var modal = document.querySelector('[data-qb-modal]');
    if (!modal) return;
    modal.querySelectorAll('[data-bwiz-panel]').forEach(function (p) {
      p.hidden = p.dataset.bwizPanel !== String(n);
    });
    bwizState.step = n;
  }

  function bwizSearch() {
    var modal = document.querySelector('[data-qb-modal]');
    if (!modal) return;

    var zipInput = modal.querySelector('[data-bwiz-zip]');
    var zipBtn = modal.querySelector('[data-bwiz-zip-btn]');
    var statusEl = modal.querySelector('[data-bwiz-status]');
    if (!zipInput || !statusEl) return;

    var zip = zipInput.value.trim();
    if (zip.length < 5) return;

    bwizState.zip = zip;
    if (zipBtn) zipBtn.disabled = true;

    statusEl.hidden = false;
    statusEl.className = 'qb-bwiz__status';
    statusEl.textContent = 'Searching for locations…';

    Promise.all([
      bwizPostJson(BWIZ_BACKEND + '/skq-locations', { zip: zip }),
      bwizPostJson(BWIZ_BACKEND + '/geo-zip', { zip: zip })
    ]).then(function (results) {
      var allLocations = results[0];
      var userCoords = results[1];

      if (zipBtn) zipBtn.disabled = zip.length < 5;

      if (!userCoords || typeof userCoords.lat !== 'number') {
        statusEl.className = 'qb-bwiz__status qb-bwiz__status--error';
        statusEl.textContent = 'ZIP code not found. Please try again.';
        zipInput.value = '';
        zipInput.focus();
        return;
      }

      if (!Array.isArray(allLocations)) {
        statusEl.className = 'qb-bwiz__status qb-bwiz__status--error';
        statusEl.textContent = 'Could not load locations. Please try again.';
        return;
      }

      var distanced = [];
      allLocations.forEach(function (loc) {
        if (!loc.latitude || !loc.longitude) return;
        var dist = bwizDistanceMi(userCoords.lat, userCoords.lng, loc.latitude, loc.longitude);
        if (!isNaN(dist)) distanced.push(Object.assign({}, loc, { _distMi: dist }));
      });

      var searchRadius = 50;
      var nearby = distanced
        .filter(function (l) { return l._distMi <= searchRadius; })
        .sort(function (a, b) { return a._distMi - b._distMi; });

      if (!nearby.length) {
        statusEl.className = 'qb-bwiz__status qb-bwiz__status--error';
        statusEl.innerHTML =
          '<p style="margin:0 0 12px">No locations within 50 miles. Please try a different ZIP or expand the search radius below.</p>' +
          '<div class="qb-bwiz__radius-expand">' +
            '<select class="qb-bwiz__radius-select" data-bwiz-radius>' +
              '<option value="75">75 miles</option>' +
              '<option value="100">100 miles</option>' +
              '<option value="150">150 miles</option>' +
              '<option value="200">200 miles</option>' +
              '<option value="250">250 miles</option>' +
              '<option value="300">300 miles</option>' +
              '<option value="400">400 miles</option>' +
              '<option value="500">500 miles</option>' +
            '</select>' +
            '<button type="button" class="qb-bwiz__retry-btn" data-bwiz-retry-radius>Try again</button>' +
          '</div>';

        var retryBtn = statusEl.querySelector('[data-bwiz-retry-radius]');
        var radiusSelect = statusEl.querySelector('[data-bwiz-radius]');
        if (retryBtn && radiusSelect) {
          retryBtn.addEventListener('click', function () {
            var newRadius = parseInt(radiusSelect.value, 10);
            var expanded = distanced
              .filter(function (l) { return l._distMi <= newRadius; })
              .sort(function (a, b) { return a._distMi - b._distMi; });
            if (!expanded.length) {
              var msg = statusEl.querySelector('p');
              if (msg) msg.textContent = 'No locations within ' + newRadius + ' miles. Please try a different ZIP.';
              return;
            }
            statusEl.hidden = true;
            bwizRenderLocations(expanded);
            bwizShowPanel(2);
          });
        }
        return;
      }

      statusEl.hidden = true;
      bwizRenderLocations(nearby);
      bwizShowPanel(2);
    });
  }

  function bwizRenderLocations(locations) {
    var modal = document.querySelector('[data-qb-modal]');
    if (!modal) return;

    modal.querySelectorAll('[data-bwiz-chip-zip]').forEach(function (el) {
      el.textContent = 'ZIP ' + bwizState.zip;
    });

    var sub = modal.querySelector('[data-bwiz-zip-sub]');
    if (sub) sub.textContent = 'Certified Crash Champions centers near ZIP ' + bwizState.zip + ', closest first.';

    var list = modal.querySelector('[data-bwiz-location-list]');
    if (!list) return;
    list.innerHTML = '';

    locations.forEach(function (loc) {
      var cleanName = loc.name ? loc.name.replace(/^\d+\s*-\s*/, '') : '';
      var stateName = loc.stateCode ? (BWIZ_STATE_NAMES[loc.stateCode] || loc.stateCode) : '';
      var address = [loc.address, loc.city, stateName].filter(Boolean).join(', ');
      var miles = loc._distMi ? loc._distMi.toFixed(1) : '';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qb-bwiz__location-item';

      var name = document.createElement('div');
      name.className = 'qb-bwiz__location-name';
      name.textContent = cleanName;

      var addr = document.createElement('div');
      addr.className = 'qb-bwiz__location-address';
      addr.textContent = address;

      var dist = document.createElement('div');
      dist.className = 'qb-bwiz__location-dist';
      if (miles) {
        var dot = document.createElement('span');
        dot.className = 'qb-bwiz__location-dist-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.textContent = '◆';
        var distText = document.createTextNode(miles + ' mi away');
        dist.appendChild(dot);
        dist.appendChild(distText);
      }

      btn.appendChild(name);
      btn.appendChild(addr);
      btn.appendChild(dist);

      btn.addEventListener('click', function () {
        bwizState.location = loc;
        window._bwizDebugLoc = loc;

        modal.querySelectorAll('[data-bwiz-chip-zip]').forEach(function (el) {
          el.textContent = 'ZIP ' + bwizState.zip;
        });

        modal.querySelectorAll('[data-bwiz-chip-location]').forEach(function (el) {
          el.textContent = cleanName + ' — ' + address;
        });

        if (window.innerWidth < 750) {
          list.querySelectorAll('.qb-bwiz__location-item').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          var locFootVal = modal.querySelector('[data-bwiz-loc-foot-val]');
          if (locFootVal) locFootVal.textContent = cleanName;
          var locBtn = modal.querySelector('[data-bwiz-loc-btn]');
          if (locBtn) locBtn.disabled = false;
        } else {
          bwizLoadTimeslots(loc);
        }
      });

      list.appendChild(btn);
    });
  }

  function bwizLoadTimeslots(loc) {
    var modal = document.querySelector('[data-qb-modal]');
    if (!modal) return;

    var calScroll = modal.querySelector('[data-bwiz-cal-scroll]');
    if (!calScroll) return;

    calScroll.innerHTML = '<p class="qb-bwiz__status" style="padding:16px 0">Loading available times…</p>';

    var timeEl = modal.querySelectorAll("[data-bwiz-selected-time]");
    timeEl.forEach(function(el) { el.textContent = 'No time selected yet'; });

    var confirmBtn = modal.querySelector('[data-bwiz-confirm]');
    if (confirmBtn) confirmBtn.disabled = true;

    bwizState.selectedTime = null;
    bwizShowPanel(3);

    bwizPostJson(BWIZ_BACKEND + '/skq-timeslots', { locationCode: loc.locationCode })
      .then(function (data) {
        calScroll.innerHTML = '';

        if (!data || !Array.isArray(data.timeSlotsByDay) || !data.timeSlotsByDay.length) {
          calScroll.innerHTML = '<p class="qb-bwiz__status qb-bwiz__status--error" style="padding:16px 0">No available times found. Try another location.</p>';
          return;
        }

        bwizRenderTimeslots(data.timeSlotsByDay, calScroll);
      });
  }

  function bwizRenderTimeslotsMobile(days, container, minTime) {
    var modal = document.querySelector('[data-qb-modal]');
    var mobileTop = modal && modal.querySelector('[data-bwiz-cal-mobile-top]');
    if (!mobileTop) return;

    mobileTop.innerHTML = '';

    var stepRow = document.createElement('div');
    stepRow.className = 'qb-bwiz__step-row';
    var stepBadge = document.createElement('span');
    stepBadge.className = 'qb-bwiz__step-badge';
    stepBadge.setAttribute('aria-hidden', 'true');
    stepBadge.textContent = '3';
    var stepTitle = document.createElement('h2');
    stepTitle.className = 'qb-bwiz__title--sm';
    stepTitle.textContent = 'Select a time';
    stepRow.appendChild(stepBadge);
    stepRow.appendChild(stepTitle);
    mobileTop.appendChild(stepRow);

    var sub = document.createElement('p');
    sub.className = 'qb-bwiz__sub';
    sub.textContent = 'Select a date & time to drop off your vehicle.';
    mobileTop.appendChild(sub);

    var partnerData = modal.querySelector('[data-bwiz-partner-logo]');
    if (partnerData) {
      var partnerBar = document.createElement('div');
      partnerBar.className = 'qb-bwiz__partner';
      var partnerImg = document.createElement('img');
      partnerImg.src = partnerData.dataset.bwizPartnerLogo;
      partnerImg.alt = partnerData.dataset.bwizPartnerLogoAlt || '';
      partnerImg.className = 'qb-bwiz__partner-logo';
      partnerImg.width = 110;
      partnerImg.loading = 'lazy';
      var partnerSep = document.createElement('div');
      partnerSep.className = 'qb-bwiz__partner-sep';
      partnerSep.setAttribute('aria-hidden', 'true');
      var partnerText = modal.querySelector('.qb-bwiz__partner-text');
      var partnerTextClone = partnerText ? partnerText.cloneNode(true) : null;
      partnerBar.appendChild(partnerImg);
      partnerBar.appendChild(partnerSep);
      if (partnerTextClone) partnerBar.appendChild(partnerTextClone);
      mobileTop.appendChild(partnerBar);
    }

    var stripWrap = document.createElement('div');
    stripWrap.className = 'qb-bwiz__date-strip-wrap';
    var strip = document.createElement('div');
    strip.className = 'qb-bwiz__date-strip';
    stripWrap.appendChild(strip);
    mobileTop.appendChild(stripWrap);

    container.innerHTML = '';
    var daySections = [];
    var dayChips = [];
    var firstValidIdx = -1;

    var minDay = new Date(minTime);
    minDay.setHours(0, 0, 0, 0);

    days.forEach(function (day, idx) {
      var dayDate = new Date(day.date);
      var isValidDate = !isNaN(dayDate.getTime());

      if (isValidDate && dayDate < minDay) return;

      var dow = isValidDate ? dayDate.toLocaleDateString('en-US', { weekday: 'short' }) : '';
      var num = isValidDate ? String(dayDate.getDate()) : '';
      var mon = isValidDate ? dayDate.toLocaleDateString('en-US', { month: 'short' }) : '';

      var groups = [
        { key: 'morningSlots', label: '☀ Morning' },
        { key: 'afternoonSlots', label: '☾ Afternoon' },
        { key: 'eveningSlots', label: '☽ Evening' }
      ];

      var hasValidSlots = groups.some(function (group) {
        var slots = day[group.key];
        if (!slots) return false;
        return slots.some(function (slot) {
          var iso = bwizConvertISO(slot.startTime, day.date);
          return iso && new Date(iso).getTime() >= minTime;
        });
      });

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'qb-bwiz__day-chip';
      if (!hasValidSlots) chip.classList.add('is-disabled');
      var dowEl = document.createElement('span');
      dowEl.className = 'qb-bwiz__day-chip-dow';
      dowEl.textContent = dow;
      var numEl = document.createElement('span');
      numEl.className = 'qb-bwiz__day-chip-num';
      numEl.textContent = num;
      var monEl = document.createElement('span');
      monEl.className = 'qb-bwiz__day-chip-mon';
      monEl.textContent = mon;
      chip.appendChild(dowEl);
      chip.appendChild(numEl);
      chip.appendChild(monEl);
      strip.appendChild(chip);
      dayChips.push(chip);

      if (firstValidIdx === -1 && hasValidSlots) firstValidIdx = daySections.length;

      var section = document.createElement('div');
      section.className = 'qb-bwiz__day-mobile';
      section.hidden = true;

      groups.forEach(function (group) {
        var slots = day[group.key];
        if (!slots || !slots.length) return;
        var validSlots = slots.filter(function (slot) {
          var iso = bwizConvertISO(slot.startTime, day.date);
          return iso && new Date(iso).getTime() >= minTime;
        });
        if (!validSlots.length) return;

        var lbl = document.createElement('div');
        lbl.className = 'qb-bwiz__period-label';
        lbl.textContent = group.label;
        section.appendChild(lbl);

        var grid = document.createElement('div');
        grid.className = 'qb-bwiz__time-grid';

        validSlots.forEach(function (slot) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qb-bwiz__slot';
          var startSuffix = slot.startTimeLabel.slice(-2);
          var endSuffix = slot.endTimeLabel.slice(-2);
          var startDisplay = (startSuffix === endSuffix)
            ? slot.startTimeLabel.replace(/\s*(AM|PM)$/, '')
            : slot.startTimeLabel;
          btn.textContent = startDisplay + ' – ' + slot.endTimeLabel;

          btn.addEventListener('click', function () {
            container.querySelectorAll('.qb-bwiz__slot.is-selected').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            bwizState.selectedTime = {
              iso: bwizConvertISO(slot.startTime, day.date),
              isoEnd: bwizConvertISO(slot.endTime, day.date),
              label: dow + ' ' + num + ' · ' + slot.startTimeLabel + ' – ' + slot.endTimeLabel
            };
            var timeEl = document.querySelectorAll("[data-bwiz-selected-time]");
            timeEl.forEach(function(el) { el.textContent = bwizState.selectedTime.label; });
            var confirmBtn = document.querySelector('[data-bwiz-confirm]');
            if (confirmBtn) confirmBtn.disabled = false;
          });

          grid.appendChild(btn);
        });
        section.appendChild(grid);
      });

      container.appendChild(section);
      daySections.push(section);

      (function (chipEl, sectionEl, hasSlots) {
        chipEl.addEventListener('click', function () {
          if (!hasSlots) return;
          dayChips.forEach(function (c) { c.classList.remove('is-active'); });
          chipEl.classList.add('is-active');
          daySections.forEach(function (s) { s.hidden = true; });
          sectionEl.hidden = false;
          container.querySelectorAll('.qb-bwiz__slot.is-selected').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          bwizState.selectedTime = null;
          var timeEl = document.querySelectorAll("[data-bwiz-selected-time]");
          timeEl.forEach(function(el) { el.textContent = 'No time selected yet'; });
          var confirmBtn = document.querySelector('[data-bwiz-confirm]');
          if (confirmBtn) confirmBtn.disabled = true;
        });
      }(chip, section, hasValidSlots));
    });

    if (firstValidIdx >= 0 && dayChips[firstValidIdx]) {
      dayChips[firstValidIdx].classList.add('is-active');
      daySections[firstValidIdx].hidden = false;
    } else if (dayChips.length) {
      dayChips[0].classList.add('is-active');
      if (daySections[0]) daySections[0].hidden = false;
    }

    if (!daySections.length) {
      container.innerHTML = '<p class="qb-bwiz__status" style="padding:16px 0">No available times found.</p>';
    }
  }

  function bwizRenderTimeslots(days, container) {
    var minTime = Date.now() + 5 * 24 * 60 * 60 * 1000;

    if (window.innerWidth < 750) {
      bwizRenderTimeslotsMobile(days, container, minTime);
      return;
    }

    days.forEach(function (day) {
      var dayDate = new Date(day.date);
      var dateLabel = isNaN(dayDate.getTime())
        ? (day.dayLabel || day.date)
        : dayDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

      var groups = [
        { key: 'morningSlots', label: '☀ Morning' },
        { key: 'afternoonSlots', label: '☾ Afternoon' },
        { key: 'eveningSlots', label: '☽ Evening' }
      ];

      var totalSlots = 0;
      var slotsGrid = document.createElement('div');
      slotsGrid.className = 'qb-bwiz__slots-grid';
      var hasSlots = false;

      groups.forEach(function (group) {
        var slots = day[group.key];
        if (!slots || !slots.length) return;

        var validSlots = slots.filter(function (slot) {
          var iso = bwizConvertISO(slot.startTime, day.date);
          return iso && new Date(iso).getTime() >= minTime;
        });

        if (!validSlots.length) return;
        hasSlots = true;
        totalSlots += validSlots.length;

        var wrap = document.createElement('div');
        var lbl = document.createElement('div');
        lbl.className = 'qb-bwiz__period-label';
        lbl.textContent = group.label;

        var grid = document.createElement('div');
        grid.className = 'qb-bwiz__time-grid';

        validSlots.forEach(function (slot) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qb-bwiz__slot';
          var startSuffix = slot.startTimeLabel.slice(-2);
          var endSuffix = slot.endTimeLabel.slice(-2);
          var startDisplay = (startSuffix === endSuffix)
            ? slot.startTimeLabel.replace(/\s*(AM|PM)$/, '')
            : slot.startTimeLabel;
          btn.textContent = startDisplay + ' – ' + slot.endTimeLabel;

          btn.addEventListener('click', function () {
            container.querySelectorAll('.qb-bwiz__slot.is-selected').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');

            bwizState.selectedTime = {
              iso: bwizConvertISO(slot.startTime, day.date),
              isoEnd: bwizConvertISO(slot.endTime, day.date),
              label: (day.dayLabel || dateLabel) + ' · ' + slot.startTimeLabel + ' – ' + slot.endTimeLabel
            };

            var timeEl = document.querySelectorAll("[data-bwiz-selected-time]");
            timeEl.forEach(function(el) { el.textContent = bwizState.selectedTime.label; });

            var confirmBtn = document.querySelector('[data-bwiz-confirm]');
            if (confirmBtn) confirmBtn.disabled = false;
          });

          grid.appendChild(btn);
        });

        wrap.appendChild(lbl);
        wrap.appendChild(grid);
        slotsGrid.appendChild(wrap);
      });

      if (!hasSlots) return;

      var dayEl = document.createElement('div');
      dayEl.className = 'qb-bwiz__day';

      var head = document.createElement('div');
      head.className = 'qb-bwiz__day-head';

      var name = document.createElement('h3');
      name.className = 'qb-bwiz__day-name';
      name.textContent = dateLabel.toUpperCase();

      var line = document.createElement('div');
      line.className = 'qb-bwiz__day-line';

      var badge = document.createElement('span');
      badge.className = 'qb-bwiz__day-badge';
      badge.textContent = totalSlots + ' OPEN';

      head.appendChild(name);
      head.appendChild(line);
      head.appendChild(badge);
      dayEl.appendChild(head);
      dayEl.appendChild(slotsGrid);
      container.appendChild(dayEl);
    });
  }

  function bwizReset() {
    bwizState.step = 1;
    bwizState.zip = '';
    bwizState.location = null;
    bwizState.selectedTime = null;

    var modal = document.querySelector('[data-qb-modal]');
    if (!modal) return;

    var zipInput = modal.querySelector('[data-bwiz-zip]');
    if (zipInput) zipInput.value = '';

    var zipBtn = modal.querySelector('[data-bwiz-zip-btn]');
    if (zipBtn) zipBtn.disabled = true;

    var statusEl = modal.querySelector('[data-bwiz-status]');
    if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }

    var timeEl = modal.querySelectorAll("[data-bwiz-selected-time]");
    timeEl.forEach(function(el) { el.textContent = 'No time selected yet'; });

    var confirmBtn = modal.querySelector('[data-bwiz-confirm]');
    if (confirmBtn) confirmBtn.disabled = true;

    var calScroll = modal.querySelector('[data-bwiz-cal-scroll]');
    if (calScroll) calScroll.innerHTML = '';

    var calMobileTop = modal.querySelector('[data-bwiz-cal-mobile-top]');
    if (calMobileTop) calMobileTop.innerHTML = '';

    var locationList = modal.querySelector('[data-bwiz-location-list]');
    if (locationList) locationList.innerHTML = '';

    var locFootVal = modal.querySelector('[data-bwiz-loc-foot-val]');
    if (locFootVal) locFootVal.textContent = 'Tap a center to continue';

    var locFootBtn = modal.querySelector('[data-bwiz-loc-btn]');
    if (locFootBtn) locFootBtn.disabled = true;

    var phoneInput = modal.querySelector('[data-bwiz-phone]');
    if (phoneInput) phoneInput.value = '';

    var phoneErrorEl = modal.querySelector('[data-bwiz-phone-error]');
    if (phoneErrorEl) { phoneErrorEl.hidden = true; phoneErrorEl.textContent = ''; }

    var submitBtn = modal.querySelector('[data-bwiz-submit]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Confirm appointment →'; }

    bwizShowPanel(1);
  }

  function initBwiz() {
    var modal = document.querySelector('[data-qb-modal]');
    if (!modal) return;

    var zipInput = modal.querySelector('[data-bwiz-zip]');
    var zipBtn = modal.querySelector('[data-bwiz-zip-btn]');

    if (zipInput && zipBtn) {
      zipInput.addEventListener('input', function () {
        var val = zipInput.value.replace(/\D/g, '').slice(0, 5);
        zipInput.value = val;
        zipBtn.disabled = val.length < 5;
        var footVal = modal.querySelector('[data-bwiz-zip-foot-val]');
        if (footVal) footVal.textContent = val.length > 0 ? 'ZIP ' + val : 'Enter your ZIP code';
      });

      zipBtn.addEventListener('click', bwizSearch);

      zipInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !zipBtn.disabled) bwizSearch();
      });
    }

    modal.addEventListener('click', function (e) {
      var toBtn = e.target.closest('[data-bwiz-to]');
      if (!toBtn) return;
      var to = parseInt(toBtn.dataset.bwizTo, 10);
      if (!isNaN(to)) bwizShowPanel(to);
    });

    var locBtn = modal.querySelector('[data-bwiz-loc-btn]');
    if (locBtn) {
      locBtn.addEventListener('click', function () {
        if (bwizState.location) bwizLoadTimeslots(bwizState.location);
      });
    }

    var confirmBtn = modal.querySelector('[data-bwiz-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        if (!bwizState.selectedTime) return;
        modal.querySelectorAll('[data-bwiz-chip-time]').forEach(function (el) {
          el.textContent = bwizState.selectedTime.label;
        });
        var phoneInput = modal.querySelector('[data-bwiz-phone]');
        if (phoneInput) phoneInput.value = '';
        var submitBtn = modal.querySelector('[data-bwiz-submit]');
        if (submitBtn) submitBtn.disabled = true;
        bwizShowPanel(4);
        if (phoneInput) phoneInput.focus();
      });
    }

    var phoneInput = modal.querySelector('[data-bwiz-phone]');
    var submitBtn = modal.querySelector('[data-bwiz-submit]');
    var phoneErrorEl = modal.querySelector('[data-bwiz-phone-error]');

    if (phoneInput && submitBtn) {
      phoneInput.addEventListener('input', function () {
        var digits = phoneInput.value.replace(/\D/g, '');
        submitBtn.disabled = digits.length < 10;
        if (phoneErrorEl) phoneErrorEl.hidden = true;
      });

      phoneInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !submitBtn.disabled) submitBtn.click();
      });

      submitBtn.addEventListener('click', function () {
        if (!bwizState.selectedTime || !bwizState.variantId) return;

        var phone = phoneInput.value.trim();
        var digits = phone.replace(/\D/g, '');
        if (digits.length < 10) {
          if (phoneErrorEl) {
            phoneErrorEl.textContent = 'Please enter a valid phone number.';
            phoneErrorEl.hidden = false;
          }
          return;
        }

        var loc = bwizState.location || {};
        var cleanName = (loc.name || '').replace(/^\d+\s*-\s*/, '');
        var stateName = loc.stateCode ? (BWIZ_STATE_NAMES[loc.stateCode] || loc.stateCode) : '';
        var streetParts = (loc.address || '').trim();
        var cityLine = [loc.city, stateName, loc.zipCode].filter(Boolean).join(', ');
        var locationAddress = [cleanName, streetParts, cityLine].filter(Boolean).join(' | ');

        var formData = new FormData();
        formData.append('id', String(bwizState.variantId));
        formData.append('quantity', '1');
        formData.append('properties[locationCode]', loc.locationCode || '');
        formData.append('properties[locationAddress]', locationAddress);
        formData.append('properties[timeslotStart]', bwizState.selectedTime.iso || '');
        formData.append('properties[timeslotEnd]', bwizState.selectedTime.isoEnd || '');
        formData.append('properties[phone]', phone);

        submitBtn.disabled = true;
        submitBtn.textContent = 'Booking…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(function (res) {
          if (res.ok) {
            window.location.href = '/checkout';
          } else {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Confirm appointment →';
          }
        }).catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Confirm appointment →';
        });
      });
    }
  }

  function stripVehiclePrefix(title) {
    var prefixes = ['Sedan ', 'Coupe ', 'Truck ', 'SUV '];
    for (var i = 0; i < prefixes.length; i++) {
      if (title.indexOf(prefixes[i]) === 0) return title.slice(prefixes[i].length);
    }
    return title;
  }

  function openBookingModal(product) {
    var overlay = document.querySelector('[data-qb-modal]');
    if (!overlay) return;

    var titleEl = overlay.querySelector('[data-qb-modal-title]');
    if (titleEl) titleEl.textContent = stripVehiclePrefix(product.title || '');

    var priceEl = overlay.querySelector('[data-qb-modal-price]');
    if (priceEl) priceEl.textContent = stripCents(product.price || '');

    var imgEl = overlay.querySelector('[data-qb-modal-img]');
    if (imgEl) { imgEl.src = product.image || ''; imgEl.alt = product.title || ''; }

    var titleM = overlay.querySelector('[data-qb-modal-title-m]');
    if (titleM) titleM.textContent = stripVehiclePrefix(product.title || '');

    var priceM = overlay.querySelector('[data-qb-modal-price-m]');
    if (priceM) priceM.textContent = stripCents(product.price || '');

    var imgM = overlay.querySelector('[data-qb-modal-img-m]');
    if (imgM) { imgM.src = product.image || ''; imgM.alt = product.title || ''; }

    var pointsEl = overlay.querySelector('[data-qb-modal-points]');
    var infoRaw = product.additionalInfo;
    var infoItems = Array.isArray(infoRaw)
      ? infoRaw.map(function (s) { return String(s).trim(); }).filter(Boolean)
      : String(infoRaw || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    renderPoints(pointsEl, infoItems);

    bwizReset();
    bwizState.variantId = product.variantId || null;

    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeBookingModal() {
    var overlay = document.querySelector('[data-qb-modal]');
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function initBookingModal() {
    var overlay = document.querySelector('[data-qb-modal]');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('[data-qb-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeBookingModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeBookingModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeBookingModal();
    });
  }

  function extractDescriptionListItems(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var ul = tmp.querySelector('ul');
    if (!ul) return [];
    var result = [];
    ul.querySelectorAll('li').forEach(function (li) {
      var text = li.textContent.trim();
      if (text) result.push(text);
    });
    return result;
  }

  function buildOtherRow(product) {
    var row = document.createElement('div');
    row.className = 'qb-other-row';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'qb-other-row__img';
    var img = document.createElement('img');
    img.src = product.image || '';
    img.alt = product.title || '';
    imgWrap.appendChild(img);

    var body = document.createElement('div');

    var tag = document.createElement('div');
    tag.className = 'qb-other-row__tag';
    tag.textContent = product.tag || '';

    var name = document.createElement('div');
    name.className = 'qb-other-row__name';
    name.textContent = product.title || '';

    var badge = document.createElement('div');
    badge.className = 'qb-other-row__badge';
    var badgeYrs = product.warrantyYears;
    badge.textContent = badgeYrs ? (badgeYrs + '-Year Warranty') : (product.warranty || '');
    if (!badgeYrs && !product.warranty) badge.style.display = 'none';

    var points = document.createElement('div');
    points.className = 'qb-other-row__points';
    var infoRaw = product.additionalInfo;
    var infoItems = Array.isArray(infoRaw)
      ? infoRaw.flatMap(function (s) { return String(s).split(' | ').map(function (t) { return t.trim(); }); }).filter(Boolean)
      : String(infoRaw || '').split(' | ').map(function (s) { return s.trim(); }).filter(Boolean);
    renderPoints(points, infoItems);

    body.appendChild(tag);
    body.appendChild(name);
    body.appendChild(badge);
    body.appendChild(points);

    var side = document.createElement('div');
    side.className = 'qb-other-row__side';

    var priceWrap = document.createElement('div');
    priceWrap.className = 'qb-other-row__price-wrap';

    var priceLabel = document.createElement('div');
    priceLabel.className = 'qb-other-row__price-label';
    priceLabel.textContent = 'Quote';

    var price = document.createElement('div');
    price.className = 'qb-other-row__price';
    price.textContent = stripCents(product.price || '');

    priceWrap.appendChild(priceLabel);
    priceWrap.appendChild(price);

    var bookBtn = document.createElement('button');
    bookBtn.type = 'button';
    bookBtn.className = 'qb-other-row__book';
    bookBtn.textContent = 'Book →';
    bookBtn.addEventListener('click', function () {
      openBookingModal(product);
    });

    side.appendChild(priceWrap);
    side.appendChild(bookBtn);

    row.appendChild(imgWrap);
    row.appendChild(body);
    row.appendChild(side);

    return row;
  }

  function renderQuoteStep() {
    var data = getProductsData();
    if (!data || !state.vehicle || !state.coverage) return;

    var vehicleProducts = data[state.vehicle];
    if (!vehicleProducts) return;

    var selected = null;
    var others = [];

    vehicleProducts.forEach(function (p) {
      if (p.handle === state.coverage) {
        selected = p;
      } else {
        others.push(p);
      }
    });

    if (!selected) return;

    var badgeEl = document.querySelector('[data-qb-quote-badge]');
    if (badgeEl) {
      var yrs = selected.warrantyYears;
      badgeEl.textContent = yrs ? (yrs + '-Year Warranty') : (selected.warranty || '');
    }

    var imageEl = document.querySelector('[data-qb-quote-image]');
    if (imageEl) {
      imageEl.src = selected.image || '';
      imageEl.alt = selected.title || '';
    }

    var titleEl = document.querySelector('[data-qb-quote-title]');
    if (titleEl) titleEl.textContent = selected.title || '';

    var priceEl = document.querySelector('[data-qb-quote-price]');
    if (priceEl) priceEl.textContent = stripCents(selected.price || '');

    var descEl = document.querySelector('[data-qb-quote-desc]');
    if (descEl) descEl.innerHTML = selected.description || '';

    var eyebrowNameEl = document.querySelector('[data-qb-quote-name]');
    if (eyebrowNameEl) eyebrowNameEl.textContent = state.customerName || '';

    var pointsEl = document.querySelector('[data-qb-quote-points]');
    renderPoints(pointsEl, selected.highlights);

    var bookBtn = document.querySelector('[data-qb-book]');
    if (bookBtn) {
      bookBtn.onclick = function () {
        openBookingModal(selected);
      };
    }

    var vehicleNameSourceEl = document.querySelector('[data-qb-vehicle-name]');
    var vehicleTitle = vehicleNameSourceEl ? vehicleNameSourceEl.textContent : '';

    var othersVehicleEl = document.querySelector('[data-qb-others-vehicle]');
    if (othersVehicleEl) othersVehicleEl.textContent = vehicleTitle;

    var listEl = document.querySelector('[data-qb-others-list]');
    if (listEl) {
      listEl.innerHTML = '';
      others.forEach(function (p) {
        listEl.appendChild(buildOtherRow(p));
      });
    }
  }

  function initStartOver() {
    var btn = document.querySelector('[data-qb-start-over]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      state.vehicle = null;
      state.coverage = null;
      showStep(1);
    });
  }

  function initDevSkip() {
    var btn = document.querySelector('[data-qb-skip]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      captureFormName();
      showStep(4);
    });
  }

  function buildQuoteUrl() {
    var n = encodeURIComponent(state.customerName || '');
    var url = window.location.origin + window.location.pathname
      + '?v=' + encodeURIComponent(state.vehicle || '')
      + '&c=' + encodeURIComponent(state.coverage || '');
    if (n) url += '&n=' + n;
    return url;
  }

  function fillQuoteLink() {
    var linkInput = document.getElementById('form_input_2');
    if (!linkInput) return;
    var wrap = linkInput.closest('.form-group');
    if (wrap) wrap.style.display = 'none';
    if (!state.vehicle || !state.coverage) return;
    linkInput.value = buildQuoteUrl();

    var nameInput = document.getElementById('form_input_0');
    if (nameInput && !nameInput._quoteLinkBound) {
      nameInput._quoteLinkBound = true;
      nameInput.addEventListener('input', function () {
        state.customerName = nameInput.value.trim();
        linkInput.value = buildQuoteUrl();
      });
    }
  }

  var _origShowStep = showStep;
  showStep = function (n) {
    _origShowStep(n);
    if (n === 3) fillQuoteLink();
  };

  function restoreFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var v = params.get('v');
    var c = params.get('c');
    if (!v || !c) return false;

    state.vehicle = v;
    state.coverage = c;
    state.customerName = decodeURIComponent(params.get('n') || '');
    showCoverageGroup(v);

    var vehicleBtn = document.querySelector('[data-qb-vehicle="' + v + '"]');
    if (vehicleBtn) {
      var nameEl = vehicleBtn.querySelector('.qb-vehicle-card__name');
      if (nameEl) setVehicleName(nameEl.textContent.trim());
    }

    var data = getProductsData();
    if (data && data[v]) {
      data[v].forEach(function (p) {
        if (p.handle === c) setCoverageName(p.title || '');
      });
    }

    return true;
  }

  initVehicleStep();
  initCoverageStep();
  initInfoButtons();
  initBackButtons();
  initStartOver();
  initDevSkip();
  initBookingModal();
  initBwiz();
  watchHulkFormSuccess();

  if (restoreFromUrl()) {
    showStep(4);
  } else {
    showStep(state.step);
  }
});